<template>
  <div>
   <!-- <v-row>
      <v-btn color="primary" text @click="changeAutomaticPayments"> {{ automaticPayments ? 'cancelar pagos automaticos' : 'Activar pagos automaticos' }}</v-btn>
      <v-spacer></v-spacer>
      <v-btn color="primary" text :to="{name: 'cardsuser'}">Ver tarjetas</v-btn>
    </v-row> -->
    <br>
    <br>
    <div v-for="(textField, index) in paymentsmainten" :key="index">
      <v-card 
        style="margin-bottom: 25px"
        :color="getColorStatus(textField.paymentDueDate, textField.paymentDate)"
      >
        <v-row>
          <v-col cols="9">
            <v-list-item two-line>
              <v-list-item-content>
                <v-list-item-title style="font-size: 15px; font-weight: 600">{{ textField.concept }}</v-list-item-title>
                <v-list-item-subtitle> {{ textField.concept }} </v-list-item-subtitle>
                 <v-list-item-subtitle>Referencia: <span style="font-weight: bold;">{{ textField.id }}</span> </v-list-item-subtitle>
                <v-list-item-subtitle> {{ $currency.format(total(textField)) }} </v-list-item-subtitle>
                <v-list-item-subtitle v-if="textField.paymentDate"> 
                  Pagado: {{ $dayjs(textField.paymentDate).format('ll') }}
                </v-list-item-subtitle>
                <v-list-item-subtitle>
                  Vence: {{ $dayjs(textField.paymentDueDate).format('ll') }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-col>

          <v-col  v-if="textField.id && textField.status === 'paid'" cols="3" class="d-flex flex-column justify-center">
            
             <!-- Para Android o iPhone sin PDF generado -->
            <div v-if="!blobUrls[textField.id] && (!isIosStandalone || (isIosStandalone && !blobUrls[textField.id]))"
              class="d-flex flex-column align-center"
            >
              <v-btn                
                dark x-large icon             
                @click="handleDownloadPDF(textField)"
              >
                <v-icon x-large
                    color="primary"                  
                    style="padding-right: 15px; padding-top: 20px; color:green">
                  {{ isIosStandalone ? 'mdi-file-plus-outline' : 'mdi-download-circle' }}
                </v-icon>               
              </v-btn>
              <span class="text-caption font-weight-medium text-center" style="color: green; margin-top: 4px; padding-right: 10px;">
                  {{ isIosStandalone ? 'Generar PDF' : 'Descargar PDF' }}
              </span>
            </div>

            <!-- Para iPhone con PDF generado -->     
            <div v-if="isIosStandalone && blobUrls[textField.id]"  class="d-flex flex-column align-center">
              <v-btn             
                color="success"
                dark x-large icon
                @click="abrirPDF(textField.id)"
              >
                <v-icon x-large
                    color="primary"                  
                    style="padding-right: 15px; padding-top: 20px; color:green">
                  mdi-eye
                </v-icon>               
              </v-btn>
              <span class="text-caption font-weight-medium text-center" style="color: green; margin-top: 4px; padding-right: 10px;">
                  Abrir PDF
              </span>
            </div>
         </v-col>
        </v-row>
        <v-card-actions class="pb-0"> 
          <v-btn
          small
            text
            color="deep-purple accent-4"
            v-if="textField.status === 'pending'"
            @click="goToPago(textField)"
          >
            <v-icon>mdi-link</v-icon> Registrar deposito o transferencia      
    
          </v-btn> 
        </v-card-actions>        
          <v-col class="pt-0">          
            <span v-if="textField.status_pago_usuario=='sin verificar'" 
                style="font-size: small; color:red">
                Deposito o transferencia en verificación por la administración</span>
            <span v-if="textField.status_pago_usuario=='rechazado'" 
                style="font-size: small; color:red">
                Pago rechazado: {{ textField.motivo_rechazo }}</span>          
          </v-col>  
      </v-card>
    </div>
  </div>
</template>


<script>
import conektaService from '@/services/users/conekta';
import adminScheduleMaintenanceService from '@/services/admin/maintenancePayments';
import userService from '@/services/users';

import dayjs from 'dayjs';
import 'dayjs/locale/es';
const localizedFormat = require('dayjs/plugin/localizedFormat');
dayjs.extend(localizedFormat);
dayjs.locale('es');

export default {
  data() {
    return {
      automaticPayments: false,
      paymentsmainten: [],
      loading: false,
      validForGenerateModelPayment: true,
      dayjs,
      textFields: [],
      items: ['pending', 'paid', 'canceled'],
      initialConcept: '',
      initialPayment: '',
      initialDate: dayjs(Date.now()).format('YYYY-MM-DD'),
      initialPayments: [],
      optionalPayments: [],
      modelPymentData: {
        startYear: dayjs(Date.now()).format('YYYY'),
        startMonth: dayjs(Date.now()).format('MM'),
        paymentDueDay: '05',
        amount: '0',
        numberMonthlyPayments: '0',
      },
       blobUrls: {}, // Clave: ID del payment; Valor: blob URL
       isIosStandalone: false,
    };
  },
  mounted() {
    this.fetch();
    this.perfil();
  
    // Detectar iOS en modo standalone (PWA instalada)
     const userAgent = window.navigator.userAgent.toLowerCase();
     const isIos = /iphone|ipad|ipod/.test(userAgent);
     const isInStandalone = window.navigator.standalone === true;
     this.isIosStandalone = isIos && isInStandalone;
  },

  computed: {
    existPayments() {
      return this.optionalPayments.some((item) => Object.prototype.hasOwnProperty.call(item, 'id'));
    },
    userId() {
      return this.$store.state.session.userId;
    },
  },

  methods: {
    changeAutomaticPayments() {
      conektaService.automaticPayments(!this.automaticPayments)
      .then( response => {
        this.automaticPayments = response.data.automaticPayments;
        let msg = 'se han desabilidatdo exitosamente.';
        if (this.automaticPayments) {
          msg = 'se ha habilitado exitosamente.';
        }
        this.$swal.fire({
          title: 'Pagos automaticos',
          html:  `Los pagos automaticos: ${msg}`,
          icon: 'info',
        });
      }).catch((error) => {
            if (error.response && [400, 404, 409].includes(error.response.status)) {
              this.$swal('Error al activar cargos automaticos', error.response.data.message, 'warning');
            }
          });
    },
    total(item) {
      if (item.forgiveSurcharges) {
        return item.amount + item.surcharges
      }
      return item.amount
    },
    getColorStatus(dueDate, paymentDate) {
      if (!paymentDate) {
        const date1 = this.$dayjs()
        const date2 = this.$dayjs(dueDate)
        return date1.diff(date2) < 0 ? 'white' : '#85d9f9';
      }
      return 'white';

    },
    perfil() {
      userService.user().then((response) => {
        this.automaticPayments = response.data.automaticPayments;
      });
    },
    fetch() {
      adminScheduleMaintenanceService.searchPayment('all', this.userId).then((response) => {
        const oneYearAgo = this.$dayjs().subtract(1, 'year');

        this.paymentsmainten = response.data
          .filter(payment => {
            const dueDate = this.$dayjs(payment.paymentDueDate);
            return dueDate.isAfter(oneYearAgo) || payment.status !== 'paid';
          })
          .sort((a, b) => {
            const dateA = this.$dayjs(a.paymentDueDate);
            const dateB = this.$dayjs(b.paymentDueDate);
            return dateA - dateB; // Ascendente
          });
      });
    },
    createPayLink(id) {
      conektaService.linkMaintenance(id).then((response) => {
        this.fetch();
        this.payLink = response.data.paymentLink;
        const html = 'De click en el siguiente link para proceder a pagar en linea. <br/>' +
        'Proceder a <a href="' + this.payLink + '" target="_blank">pagar</a> ';
        this.$swal.fire({
          title: 'Se ha generado el link de pago',
          html,
          icon: 'info',
        });
      });
    },
    async downloadPDF(payment) {         
      adminScheduleMaintenanceService.receiptPdf(payment.customer.username, payment.customer.usernameLogin, payment.amount/100, payment.paymentDate, 
        payment.concept
      )
      .then( response => {
       // console.log(response);        
        const file = new Blob([response.data], { type: 'application/pdf' });
        const fileURL = URL.createObjectURL(file);
        window.open(fileURL); // Opens the PDF in a new tab
      })
      .catch (error => {
        console.error("Error downloading PDF:", error);
    })
    },
    async handleDownloadPDF(payment) {
      try {
        const response = await adminScheduleMaintenanceService.receiptPdf(
          payment.customer.username,
          payment.customer.usernameLogin,
          payment.amount / 100,
          payment.paymentDate,
          payment.concept
        );

        const blob = new Blob([response.data], { type: 'application/pdf' });
        const url = URL.createObjectURL(blob);

        // Guardar blobUrl por ID
        this.$set(this.blobUrls, payment.id, url);

        if (!this.isIosStandalone) {
          window.open(url, '_blank');
          URL.revokeObjectURL(url);
          this.$delete(this.blobUrls, payment.id);
        } else {
          alert('PDF generado. Toca "Abrir PDF" para visualizarlo.');
        }
      } catch (error) {
        console.error('Error al generar PDF:', error);
        alert('Ocurrió un error al generar el PDF.');
      }
    },

    abrirPDF(paymentId) {
      const url = this.blobUrls[paymentId];
      if (url) {
        window.open(url, '_blank');
        URL.revokeObjectURL(url);
        this.$delete(this.blobUrls, paymentId);
      } else {
        alert('Primero genera el PDF.');
      }
    },
    goToPago(pago) {
      this.$router.push({ name: 'userpay', params: { pagoId: String(pago.id) } });
    }
  },
};
</script>